declare var window: { dataLayer: DatalayerEvent[] };

export interface DatalayerEvent {
  [key: string]: string
}

export const push = (event: DatalayerEvent) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
}
